class Component{

    _isReady(){
        return true;
    }

    _run(){
    }

    init(){
        if(this._isReady()){
            try{
                this._run();
            }catch ($e){
                console.error($e);
            }
        }
    }
}
export default Component;
